
const config = {
    ajaxUrl:  $('#basketItems').data('url'),
    batchSize: 5,
    elementsSelector: '.c-basket-listing',
    loadingClass: 'u-loading',
    isHidden: 'is-hidden',
    basketCount: '.js-basket-count',
    exportButton: '.js-export-basket',
    fadeOutTime: 500 // this must match the transition time in basket-listing.less
};

$(document).ready(function ($) {
    let elementPlaceholders = $(config.elementsSelector+'.'+config.loadingClass);
    let groups = splitArray(elementPlaceholders, config.batchSize);

    groups.forEach(function (group) {
        let productIds = group.map(function (key, element) {
            return $(element).data('stocknumber');
        });

        loadProducts(productIds).always(productsData => {
            if(productsData.length === 0 && productIds.length === 0) {
                return;
            }

            if(!Array.isArray(productsData)) {
                productsData = [];
            }

            let outputIds = [];
            productsData.forEach(product => {
                outputIds.push(String(product.stockNumber))
            });

            // append products that were not returned as unavailable
            productIds.toArray().forEach(inputId => {
               if(!outputIds.includes(String(inputId))) {
                   productsData.push({
                       stockNumber: String(inputId),
                       source: 'none'
                   })
               }
            });

            productsData.forEach(product => {
                if(product.source === 'none') {
                    updateUnavailableProduct(product);
                } else {
                    updateProduct(product);
                }
            })
        });
    });

    watchQuantity();

    function loadProducts(productIds) {
        let ids = [];
        for(let i = 0 ; i < productIds.length ; i++) {
            ids.push(productIds[i]);
        }

        return $.ajax({
            url: config.ajaxUrl,
            data: {'id':ids},
            dataType: 'json'
        });
    }

    function updateProduct(product) {
        let element = $("*[data-stocknumber='" + product.stockNumber + "']");

        element.find('.js-product__quantity').val(element.data('quantity'));
        element.find('.js-product__quantity-update').hide();
        element.find('.js-product__product-link').attr('href', product.purchaseUrl);
        element.find('.js-product__product-link').text(product.humanReadableStockNumber);
        element.find('.js-product__description').text(product.name);
        element.find('.js-product__mpn').text(product.manufacturerPartNumber);
        element.find('.js-product__price').text(product.displayPrice);
        element.find('.js-product__image').attr('src', product.imageUrl);
        element.find('.js-product__image').attr('alt', product.name);

        if (product.source === 'allied') {
            element.find('.js-label-allied').removeClass(config.isHidden);
            element.find('.js-buy-allied').attr('href', product.purchaseUrl);
            element.find('.js-buy-allied').removeClass(config.isHidden);
        }

        element.removeClass(config.loadingClass);
    }

    function updateUnavailableProduct(product) {
        let element = $("*[data-stocknumber='" + product.stockNumber + "']");
        let stockNumber = $("*[data-stocknumber='" + product.stockNumber + "']").find('.js-product-unavailable-stock-number');

        element.addClass('c-basket-listing--unavailable');
        stockNumber.removeClass(config.isHidden);
        stockNumber.find('.js-product__product-link').text(product.stockNumber);
        element.find('.js-product__description').hide();
        element.find('.js-product__image').attr('alt', product.stockNumber);
        element.find('.js-label-unavailable').removeClass(config.isHidden);
        element.removeClass(config.loadingClass);
    }

    function splitArray(data, maxPerGroup) {
        var groups = [];
        for (var index = 0; index < data.length; index += maxPerGroup) {
            groups.push(data.slice(index, index + maxPerGroup));
        }
        return groups;
    }

    function watchQuantity() {
        $('.js-product__quantity').change(function() {
            const $this = $(this);
            const $parent = $this.parents('.c-basket-listing');
            const $update = $this.next('.js-product__quantity-update');
            let stockNumber = [];
            stockNumber.push($parent.data('stocknumber'));

            // only apply once
            if(!$update.is(":visible")) {
                $update.show();
                $update.one('click', function(e) {
                    e.preventDefault();
                    const $element = $(this);
                    const ajaxUrl = $element.attr('href');
                    const currentValue = Math.abs($this.val());
                    let quantity = [];
                    quantity.push(currentValue);
                    $element.hide();

                    if(currentValue === 0) {
                        $parent.css({'opacity': 0});
                        setTimeout(function() {
                            $parent.remove();
                        }, config.fadeOutTime);
                    }

                    $.ajax({
                        url: ajaxUrl,
                        data: {stockNumber: stockNumber, quantity: quantity},
                        success: function (result, textStatus, request) {
                            const newBasketCount = request.getResponseHeader('X-Item-Count');
                            $(config.basketCount).text(newBasketCount);
                            $(config.exportButton).attr('href', request.getResponseHeader('X-Export-Url'));

                            // refresh the page if basket is empty
                            if (newBasketCount === '0') {
                                document.location.reload();
                            }
                        }
                    });
                });
            }
        });
    }
});



// WEBPACK FOOTER //
// ./src/js/components/product-listing.js